import api from "./axiosInstance";

/**
 * @param {number} limit
 * @param {number} offset
 */
export const getShortenLinks = async (limit = 10, offset = 0) => {
  const response = await api.get(
    `api/v1/short-links/?limit=${limit}&offset=${offset}`
  );
  return response.data;

};

export const createShortenLink = async (payload) => {
  const response = await api.post(
    "api/v1/short-links/",
    payload
  );
  return response.data;
};

export const updateShortenLinkStatus = async (linkId, payload) => {
  const response = await api.post(
    `api/v1/short-links/${linkId}/toggle-active/`
  );
  return response.data;
};


export const deleteShortenLink = async (linkId) => {
  await api.delete(`api/v1/short-links/${linkId}/`);
};

